import http from './http';

// Tailles de page proposées par l'écran. ⛔ Plafond côté API = 200 (`VIEWS_MAX_PAGE_SIZE`,
// website_controller.getViews). Les compléments par ligne y sont GROUPÉS (3 agrégations par
// page, pas par ligne), mais chaque ligne reste un site peuplé sur le fil : ne pas ajouter 500
// ici sans relever le plafond serveur.
export const PAGE_SIZES = [50, 100, 200];
export const DEFAULT_PAGE_SIZE = 50;

// « Plans payants » = `rights` expert + custom (même définition que `Website.isExpertOrCustomEnable`
// côté API). `free` couvre aussi les sites sans champ `rights` (défaut Mongoose).
export const PAID_RIGHTS = 'expert,custom';

/**
 * Liste des sites ayant des chargements sur un mois, triée par `nbLoad` desc (départagée par
 * l'id du site côté API — pagination stable). `sort_field` est inerte côté API (seul le tri
 * `nbLoad` existe ; `sort_type` asc/desc, lui, est honoré) : conservé pour la compatibilité du
 * contrat, et verrouillé tel quel par `statViewsService.test.js`.
 *
 * @param {number} page
 * @param {string} month '1'..'12' ou '' (défaut API : mois courant)
 * @param {string} year  ou '' (défaut API : année courante)
 * @param {object} [opts]
 * @param {number} [opts.pageSize=50]
 * @param {string} [opts.rights]  csv `free|expert|custom` — vide = tous les plans
 * @param {string} [opts.query]   recherche d'un site : `_id` exact, nom ou clé publique
 */
const getStatViews = (page, month, year, opts = {}) => {
  const { pageSize = DEFAULT_PAGE_SIZE, rights = '', query = '' } = opts;
  const m = month ? `&month=${encodeURIComponent(month)}` : '&month=false';
  const y = year ? `&year=${encodeURIComponent(year)}` : '&year=false';
  const r = rights ? `&rights=${encodeURIComponent(rights)}` : '';
  const q = query && String(query).trim() ? `&query=${encodeURIComponent(String(query).trim())}` : '';
  return http.get(`/website/views?page_size=${pageSize}&page_nbr=${page}&sort_field=nbLoad&sort_type=desc${m}${y}${r}${q}`);
};

const statViewsService = { getStatViews };

export default statViewsService;
export { getStatViews };
